export enum OrganisationRole {
  NoAccess,
  User = 1 << 1,
  UserAdministrator = 1 << 3,
  SystemAdministrator = 1 << 4,
}